import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'vex-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit,OnDestroy {

  private destroy$ = new Subject<void>();
  constructor(public loader: LoadingBarService) { }

  ngOnInit() {
  }

   ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
 }

}
